import AccountManagersAPI from '@/API/users/account-managers-api'

export default {
  namespaced: true,
  state: {
    managers: [],
    admins: [],
    managerFetched: false,
  },
  getters: {
    managers: (state: any) => state.managers,
    admins: (state: any) => state.admins,
    managerFetched: (state: any) => state.managerFetched,
  },
  mutations: {
    SET_MANAGERS(state: any, payload: any) {
      state.managers = payload
      state.managerFetched = true
    },
    SET_ADMINS(state: any, payload: any) {
      state.admins = payload
    },
  },
  actions: {
    async FETCH_MANAGERS(context: any) {
      if (context.state.managerFetched) return
      await AccountManagersAPI.getAccountManagersList()
        .then(managers => {
          context.commit('SET_MANAGERS', managers)
        })
        .catch(() => null)
    },
  },
}
